/** ノードグラフの隣接リスト（docs/03_simulation.md 2 章）。臨時ノードを後から足せる */
import type { EdgeData, NodeData, WorldData } from '../../core/world';

export interface Arc {
  to: number;
  edgeId: number;
  /** true なら edge の a → b の向き */
  forward: boolean;
}

export interface Graph {
  nodes: NodeData[];
  edges: EdgeData[];
  arcs: Arc[][];
}

/** world の配列はコピーする（臨時ノードの追加が world を変えないように） */
export function buildGraph(world: Pick<WorldData, 'nodes' | 'edges'>): Graph {
  const graph: Graph = { nodes: [...world.nodes], edges: [], arcs: world.nodes.map(() => []) };
  for (const e of world.edges) addEdge(graph, e);
  return graph;
}

export function addEdge(graph: Graph, e: EdgeData): void {
  graph.edges[e.id] = e;
  graph.arcs[e.a]?.push({ to: e.b, edgeId: e.id, forward: true });
  graph.arcs[e.b]?.push({ to: e.a, edgeId: e.id, forward: false });
}

export function addNode(graph: Graph, node: NodeData): void {
  graph.nodes[node.id] = node;
  graph.arcs[node.id] = [];
}
